/**
 * @file index.tsx
 *
 * @fileoverview Renders blog tag badge.
 */
import Link from '~/jobiqo/components/Link';
import { Term } from '~/jobiqo/types/types';
import { Badge } from '~/vcl/atoms/03-badge';
import { TagsIcon } from '~/vcl/icons/Tags';
import { getFrontendTheme } from '~/jobiqo/utils/getFrontend';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

export interface BlogTagBadgeProps {
  /**
   * The tag.
   */
  tag?: Term;
  /**
   * The badge fontSize.
   */
  fontSize?: string;
  /**
   * The amount of articles for a given tag.
   */
  amount?: number;
  /**
   * The flag to show the tag icon.
   *
   * @default true
   */
  showTagIcon?: boolean;
}

export default function BlogTagBadge({
  tag,
  fontSize,
  amount,
  showTagIcon = true,
}: BlogTagBadgeProps) {
  const frontendConfig = useFrontendConfig();
  const frontendTheme = getFrontendTheme(frontendConfig);

  if (!tag) {
    return null;
  }

  return (
    <Link href={tag.url?.path}>
      <Badge
        badgeStyle={frontendTheme.BLOG.POPULAR_TAGS.STYLE}
        fontSize={fontSize}
      >
        {showTagIcon && <TagsIcon />}
        <span>
          {tag.label}
          {amount && ` (${amount})`}
        </span>
      </Badge>
    </Link>
  );
}

export { BlogTagBadge };
